export const VALUE_TYPE_SINGLE = 'Single';
export const VALUE_TYPE_MULTIPLE = 'Multiple';

export const PARAMETER_TYPE_STATIC = 'Static';
export const PARAMETER_TYPE_DYNAMIC = 'Dynamic';